import { categories } from './categories';

export const articles = [
  {
    id: 1,
    title: '如何识别亲密关系中的情感依恋模式',
    slug: 'identify-emotional-attachment-patterns',
    category: 'emotional-consultation',
    categoryName: '情感咨询',
    excerpt: '了解四种情感依恋模式，帮助你认清自己在亲密关系中的行为模式，从而建立更健康的情感连接。',
    content: `<p>在亲密关系中，我们每个人都会展现出特定的情感依恋模式。这些模式往往源于我们童年时期与主要照顾者的互动经历，并在成年后深刻影响着我们与伴侣的相处方式。</p>

<h2>什么是情感依恋理论</h2>
<p>情感依恋理论由心理学家约翰·鲍尔比（John Bowlby）提出，经玛丽·安斯沃斯（Mary Ainsworth）进一步发展和验证。该理论认为，人类天生具有与他人建立情感连接的倾向，而这种连接的质量直接影响着我们的心理健康和人际关系。</p>

<h2>四种情感依恋模式</h2>

<h3>1. 安全型依恋</h3>
<p>安全型依恋的人能够在亲密关系中保持适度的独立性和亲密感。他们信任伴侣，同时也能保持自我边界。这类人在关系中通常表现得自信、开放、善于沟通。</p>
<p>特征：能够自如地表达情感需求；对伴侣的暂时离开不会过度焦虑；在冲突中能够冷静沟通；对关系持乐观态度。</p>

<h3>2. 焦虑型依恋</h3>
<p>焦虑型依恋的人极度渴望亲密感，但又常常担心被抛弃。他们需要不断的确认和关注，容易将伴侣的冷淡解读为拒绝的信号。</p>
<p>特征：频繁寻求伴侣的确认和保证；对关系中的细微变化过度敏感；容易产生嫉妒情绪；害怕独处。</p>

<h3>3. 回避型依恋</h3>
<p>回避型依恋的人倾向于保持情感距离，将独立看得比亲密更重要。他们可能在不自觉中推开伴侣，在感到压力时选择退缩。</p>
<p>特征：难以敞开心扉表达真实感受；将独处视为充电方式而非孤独；在冲突中选择沉默或离开；对过分亲密感到不适。</p>

<h3>4. 混乱型依恋</h3>
<p>混乱型依恋是最复杂的一种模式，同时具有焦虑型和回避型的特征。这类人既渴望亲密又害怕受伤，在关系中表现出矛盾和不稳定的行为。</p>
<p>特征：行为模式不稳定，时冷时热；内心深处对亲密关系既渴望又恐惧；可能在关系中重复创伤经历。</p>

<h2>如何改善你的依恋模式</h2>
<p>了解自己的依恋模式是改变的第一步。通过自我觉察、与伴侣的坦诚沟通，以及在必要时寻求专业心理咨询的帮助，我们都有能力逐步发展出更安全、更健康的依恋方式。</p>
<p>记住，依恋模式不是一成不变的宿命，而是可以通过努力和觉察来调整的行为模式。每一段健康的关系都是一次成长的机会。</p>`,
    author: '李晓婷',
    authorTitle: '资深情感咨询师',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20warm%20lighting%2C%20friendly%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20look%2C%20editorial%20portrait%20photography%2C%20warm%20tones&width=200&height=200&seq=author-lx-01&orientation=squarish',
    date: '2026-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Couple%20sitting%20closely%20on%20a%20comfortable%20sofa%20in%20a%20warm%20living%20room%2C%20soft%20evening%20light%2C%20gentle%20embrace%2C%20emotional%20connection%2C%20cream%20and%20warm%20beige%20interior%2C%20intimate%20atmosphere%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=article-attach-01&orientation=landscape',
    featured: true,
  },
  {
    id: 2,
    title: '伴侣沟通中的五个致命误区，你中了几条？',
    slug: 'five-communication-mistakes-couples-make',
    category: 'partner-communication',
    categoryName: '伴侣沟通',
    excerpt: '沟通是亲密关系的基石，但许多伴侣在不经意间陷入了破坏性沟通模式。看看这些常见误区你是否也有？',
    content: `<p>在长期伴侣关系中，沟通质量直接决定了关系的满意度和持久性。研究发现，预测一段关系能否长久的最重要因素，不是争吵的频率，而是争吵的方式。</p>

<h2>误区一：以"你"开头的指责句式</h2>
<p>"你总是..."、"你从来不..."——这种句式一出，对方的防御机制立即启动。有效的沟通应该使用"我"陈述句，表达自己的感受而非指责对方。例如，与其说"你总是加班不陪我"，不如说"当你工作很晚时，我感到有些孤单"。</p>

<h2>误区二：在情绪高涨时强行沟通</h2>
<p>当你们中的一方或双方处于愤怒、沮丧等强烈情绪中时，大脑的理性思考能力会显著下降。此时强行沟通往往适得其反。学会暂停，给自己和对方一个冷静的时间窗口。</p>

<h2>误区三：翻旧账</h2>
<p>在当前的争执中搬出三个月甚至三年前的旧事，这不仅会让问题变得更加复杂，还会让对方觉得你一直在记恨，从未真正原谅。每次沟通聚焦于当下的一个具体问题。</p>

<h2>误区四：读心术式的期待</h2>
<p>"你应该知道我在想什么"——这是亲密关系中最不切实际的期待之一。即使是最亲密的伴侣也不是你肚子里的蛔虫。清晰地表达自己的需求和期待，是成熟关系的重要标志。</p>

<h2>误区五：逃避冲突</h2>
<p>表面上的和平不等于真正的和谐。压抑不满和委屈只会让负面情绪积累，最终以更激烈的形式爆发。学会健康地面对和解决冲突，才是关系长久的秘诀。</p>

<h2>改善沟通的实用建议</h2>
<p>每周安排固定的"关系检查"时间，在轻松的氛围中分享彼此的感受和想法。使用"倾听-反馈"模式：一方说话时，另一方先复述理解再回应。这些小小的改变，会对关系质量产生深远的影响。</p>`,
    author: '王明辉',
    authorTitle: '两性关系专家',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20confident%20expression%2C%20simple%20cream%20background%2C%20editorial%20portrait%20photography%2C%20clean%20professional%20look%2C%20warm%20tones&width=200&height=200&seq=author-wm-02&orientation=squarish',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20having%20a%20calm%20conversation%20in%20a%20modern%20bright%20living%20room%2C%20natural%20daylight%2C%20attentive%20listening%2C%20positive%20body%20language%2C%20warm%20neutral%20interior%20design%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=article-comm-02&orientation=landscape',
    featured: true,
  },
  {
    id: 3,
    title: '两性健康：打破关于性健康的常见迷思',
    slug: 'sexual-health-common-myths',
    category: 'sexual-health',
    categoryName: '两性健康',
    excerpt: '关于性健康，社会上流传着许多不准确的说法。让我们从科学角度澄清这些常见误区，建立正确的健康观念。',
    content: `<p>在信息爆炸的时代，关于性健康的说法五花八门，其中不乏一些广为流传但缺乏科学依据的迷思。今天，我们邀请专业医师为大家澄清几个最常见的误区。</p>

<h2>迷思一：性健康问题只出现在中老年人身上</h2>
<p>这是一个非常普遍的误解。实际上，性健康问题可能发生在任何年龄段。年轻人的性功能障碍往往与心理压力、不健康的生活方式有关，而非单纯的生理退化。关注性健康应该从年轻时就开始。</p>

<h2>迷思二：频率越高代表关系越好</h2>
<p>每对伴侣都有自己的节奏和偏好。性生活的质量远比数量重要。强迫自己达到所谓的"正常"频率只会增加不必要的压力。真正重要的是双方的满足感和情感连接。</p>

<h2>迷思三：性健康问题只能自己默默承受</h2>
<p>许多人因为羞耻感而选择独自面对性健康问题，这恰恰是最不可取的做法。大多数性健康问题都有有效的治疗方案。专业的医疗帮助和伴侣的支持是解决问题的关键。</p>

<h2>迷思四：只有身体疾病才影响性健康</h2>
<p>性健康与心理健康密切相关。焦虑、抑郁、压力、过往创伤经历等心理因素都可能显著影响性功能。全面关注身心健康才是正确的做法。</p>

<h2>建立正确的性健康观念</h2>
<p>定期体检是维护性健康的重要环节。与伴侣保持开放的沟通，与医生坦诚交流你的担忧。健康的性生活是整体健康的重要组成部分，值得我们认真对待。</p>`,
    author: '张明华',
    authorTitle: '医学博士、性健康专家',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20doctor%20portrait%20in%20white%20coat%2C%20warm%20smile%2C%20simple%20clean%20background%2C%20professional%20medical%20portrait%20photography%2C%20warm%20lighting%2C%20approachable%20expression&width=200&height=200&seq=author-zm-03&orientation=squarish',
    date: '2026-07-20',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20office%20with%20soft%20lighting%2C%20fresh%20flowers%20on%20desk%2C%20professional%20yet%20warm%20atmosphere%2C%20cream%20and%20soft%20green%20tones%2C%20wellness%20theme%2C%20editorial%20photography&width=1200&height=675&seq=article-health-03&orientation=landscape',
    featured: true,
  },
  {
    id: 4,
    title: '异地恋维系指南：距离不是感情的终点',
    slug: 'long-distance-relationship-guide',
    category: 'emotional-consultation',
    categoryName: '情感咨询',
    excerpt: '异地恋并非注定失败。掌握正确的维系方法，距离反而可能成为你们感情的催化剂。',
    content: `<p>在当今社会，因工作、学业等原因导致的异地恋越来越普遍。虽然空间距离带来了挑战，但无数伴侣的成功经验证明，异地恋也可以开花结果。</p>

<h2>建立稳定的沟通节奏</h2>
<p>找到适合两个人的沟通频率比盲目追求"时刻在线"更为重要。有些伴侣喜欢每天视频，有些则更适应每隔几天的深度交流。关键是找到让你们都感到舒适的节奏。</p>

<h2>创造共同的期待</h2>
<p>一起规划下一次见面的时间、地点和活动。这份共同的期待会成为支撑彼此度过分离时光的重要力量。倒数计时的日子里，每一天都充满了希望。</p>

<h2>善用科技，但不依赖科技</h2>
<p>视频通话、即时消息让异地沟通变得前所未有的便利。但同时，也要给彼此留出各自生活的空间。过度的在线监控只会滋生不信任和窒息感。</p>

<h2>信任是异地恋的基石</h2>
<p>没有信任，异地恋几乎无法存活。学会相信对方，也让自己值得被信任。如果你发现自己总是忍不住怀疑对方，这可能是你们需要深入沟通的信号。</p>`,
    author: '李晓婷',
    authorTitle: '资深情感咨询师',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20warm%20lighting%2C%20friendly%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20look%2C%20editorial%20portrait%20photography%2C%20warm%20tones&width=200&height=200&seq=author-lx-01&orientation=squarish',
    date: '2026-07-18',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20each%20other%20on%20a%20wooden%20table%20with%20warm%20coffee%2C%20cozy%20home%20setting%2C%20soft%20natural%20light%2C%20warm%20and%20sentimental%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography&width=1200&height=675&seq=article-distance-04&orientation=landscape',
    featured: false,
  },
  {
    id: 5,
    title: '如何与伴侣讨论敏感话题而不引发争吵',
    slug: 'discuss-sensitive-topics-with-partner',
    category: 'partner-communication',
    categoryName: '伴侣沟通',
    excerpt: '金钱、前任、家庭边界...这些敏感话题常常是争吵的导火索。学会正确的讨论方式，让困难对话变得建设性。',
    content: `<p>每段关系中都会有一些"雷区"话题——一旦触碰就可能引发争吵。但回避这些话题并不是长久之计。掌握正确的讨论技巧，才能让关系在解决困难中不断成长。</p>

<h2>选择合适的时间和地点</h2>
<p>不要在疲惫的深夜、匆忙的早晨或者公共场合开启敏感话题。选择一个双方都放松、有足够时间、且私密的环境。你可以说："我有些想和你聊聊的事情，你什么时候方便？"</p>

<h2>使用"软启动"技巧</h2>
<p>以温和的方式开场，而非直接抛出指责或抱怨。例如，与其说"你花钱太没节制了"，不如说"我最近对我们的财务状况有些担忧，我们能一起看看吗？"</p>

<h2>保持好奇心而非攻击性</h2>
<p>当你对伴侣的行为感到不解时，试着用好奇而非指责的态度提问。"你能帮我理解为什么这对你很重要吗？"这样的问题开启了对话，而不是关闭了它。</p>

<h2>学会在讨论中按下暂停键</h2>
<p>当情绪开始升温时，主动提出暂停。"我现在情绪有些激动，需要休息十分钟冷静一下，但我想继续这个对话。"重要的是要明确表示你会回来继续，而不是逃避。</p>`,
    author: '王明辉',
    authorTitle: '两性关系专家',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20confident%20expression%2C%20simple%20cream%20background%2C%20editorial%20portrait%20photography%2C%20clean%20professional%20look%2C%20warm%20tones&width=200&height=200&seq=author-wm-02&orientation=squarish',
    date: '2026-07-15',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Couple%20having%20a%20serious%20yet%20calm%20discussion%20in%20a%20cozy%20living%20room%2C%20soft%20evening%20light%20from%20a%20lamp%2C%20warm%20neutral%20interior%2C%20respectful%20body%20language%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=article-sensitive-05&orientation=landscape',
    featured: false,
  },
  {
    id: 6,
    title: '亲密关系中的边界感：爱不是失去自我',
    slug: 'boundaries-in-intimate-relationships',
    category: 'intimacy-relationship',
    categoryName: '亲密关系',
    excerpt: '健康的亲密关系需要在"我们"和"我"之间找到平衡。学会建立和维护个人边界，是持久爱情的重要课题。',
    content: `<p>很多人误以为亲密关系意味着完全的融合——两个人变成一个人。但事实上，健康的亲密关系恰恰需要清晰的个人边界。没有边界的爱，往往会变成窒息的控制或失去自我的依附。</p>

<h2>什么是亲密关系中的边界</h2>
<p>边界不是将伴侣推开的高墙，而是定义"我是谁"和"我们是谁"的健康分界线。它包括物理边界、情感边界、时间边界、社交边界等多个维度。</p>

<h2>为什么要建立边界</h2>
<p>清晰的边界让两个独立的个体能够在关系中保持自我完整性。它减少了怨恨的积累——当你总是勉强自己做不愿意做的事，怨恨就会悄悄滋生。边界保护了彼此的自由和尊严。</p>

<h2>如何温和地设立边界</h2>
<p>设立边界不需要强硬或粗暴。你可以温柔而坚定地表达自己的需求。"我需要每周有一点独处时间来充电"——这样的表达既清晰又尊重对方。记住，你不需要为保护自己的边界而道歉。</p>

<h2>尊重伴侣的边界同样重要</h2>
<p>建立边界是双向的。当你希望伴侣尊重你的边界时，你也需要以同样的尊重对待他们的边界。这包括不强迫、不操控、不因为对方的独立需求而感到被冒犯。</p>`,
    author: '陈文静',
    authorTitle: '心理咨询师',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20with%20gentle%20smile%2C%20simple%20cream%20background%2C%20warm%20lighting%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20approachable%20look&width=200&height=200&seq=author-cw-06&orientation=squarish',
    date: '2026-07-12',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Person%20meditating%20peacefully%20in%20a%20sunlit%20room%20with%20plants%2C%20calm%20and%20serene%20atmosphere%2C%20self-care%20theme%2C%20cream%20and%20soft%20green%20tones%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=article-boundary-06&orientation=landscape',
    featured: false,
  },
  {
    id: 7,
    title: '从失恋中走出来：科学有效的情绪恢复指南',
    slug: 'recovering-from-breakup-guide',
    category: 'self-growth',
    categoryName: '自我成长',
    excerpt: '失恋的痛苦是真实的，但恢复的道路也是清晰的。从科学角度了解情绪恢复的过程，让你更快重新站起来。',
    content: `<p>失恋是人生中最痛苦的经历之一。研究表明，失恋激活的大脑区域与身体疼痛激活的区域高度重叠——所以"心碎"的感觉是真实存在的，不只是比喻。</p>

<h2>理解悲伤的五个阶段</h2>
<p>心理学家伊丽莎白·库伯勒-罗斯提出的悲伤五阶段模型同样适用于失恋：否认、愤怒、讨价还价、抑郁、接受。了解这些阶段的正常性，可以帮助你不为自己的情绪反应感到恐慌。</p>

<h2>允许自己悲伤，但不沉溺其中</h2>
<p>给自己设定一个合理的悲伤期限。在这段时间里，允许自己哭、倾诉、写日记。但也要设定一个终点线，从那里开始，每多沉溺一天都是对自己生命的一种浪费。</p>

<h2>重建生活的秩序</h2>
<p>失恋后，日常生活的节奏往往被打乱。从恢复规律的作息、饮食和运动开始，重新建立起生活的掌控感。这些小而确定的习惯会成为你情绪稳定器。</p>

<h2>社交支持的力量</h2>
<p>不要独自承受。朋友、家人、支持小组——社交连接是情绪恢复最强大的资源之一。让关心你的人陪伴你走过这段艰难时光。</p>`,
    author: '陈文静',
    authorTitle: '心理咨询师',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20with%20gentle%20smile%2C%20simple%20cream%20background%2C%20warm%20lighting%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20approachable%20look&width=200&height=200&seq=author-cw-06&orientation=squarish',
    date: '2026-07-08',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Person%20looking%20out%20of%20a%20window%20at%20sunrise%2C%20new%20beginning%20symbolism%2C%20hopeful%20and%20peaceful%20mood%2C%20soft%20golden%20morning%20light%2C%20warm%20cream%20and%20coral%20tones%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=article-recover-07&orientation=landscape',
    featured: false,
  },
  {
    id: 8,
    title: '夫妻性生活不和谐？可能是这些心理因素在作祟',
    slug: 'psychological-factors-affecting-sex-life',
    category: 'sexual-health',
    categoryName: '两性健康',
    excerpt: '当夫妻性生活出现问题时，很多人首先想到的是生理原因。但实际上，心理因素往往是更关键的幕后推手。',
    content: `<p>调查显示，超过60%的性生活不和谐问题与心理因素有关，而非单纯的生理问题。了解这些心理因素的影响，是解决问题的第一步。</p>

<h2>压力：欲望的头号杀手</h2>
<p>工作压力、经济压力、育儿压力——现代生活中无处不在的压力源会显著抑制性欲。当大脑长期处于"战斗或逃跑"的模式时，身体很难切换到放松和享受的状态。学会管理压力，往往能带来意想不到的改善。</p>

<h2>未解决的冲突</h2>
<p>卧室里的问题往往源于卧室外的矛盾。未解决的情感冲突会在潜意识中转化为身体上的疏远。当你们在床上感觉不到亲密时，不妨先看看白天的关系中发生了什么。</p>

<h2>身体意象问题</h2>
<p>对自己身体的不满意会严重影响性生活的质量和频率。当你总是在意自己的身材、皮肤或其他身体特征时，很难完全放松地享受亲密时刻。</p>

<h2>性观念的包袱</h2>
<p>从小接受的性教育、成长环境中的性观念会在无形中影响成年后的性态度。一些根深蒂固的负面观念可能成为亲密关系中看不见的障碍。</p>

<h2>解决之道</h2>
<p>坦诚地沟通各自的感受和担忧。如果需要，寻求专业的性治疗师或心理咨询师的帮助。记住，性生活不和谐是可以改善的，你们不是孤单的。</p>`,
    author: '张明华',
    authorTitle: '医学博士、性健康专家',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20doctor%20portrait%20in%20white%20coat%2C%20warm%20smile%2C%20simple%20clean%20background%2C%20professional%20medical%20portrait%20photography%2C%20warm%20lighting%2C%20approachable%20expression&width=200&height=200&seq=author-zm-03&orientation=squarish',
    date: '2026-07-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Couple%20sitting%20on%20a%20bed%20talking%20gently%2C%20warm%20bedroom%20lighting%2C%20soft%20linen%20bedding%2C%20intimate%20yet%20wholesome%20atmosphere%2C%20cream%20and%20warm%20beige%20tones%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=article-psych-08&orientation=landscape',
    featured: false,
  },
  {
    id: 9,
    title: '在爱中成长：如何让亲密关系成为个人进化的催化剂',
    slug: 'grow-through-love-relationship-growth',
    category: 'self-growth',
    categoryName: '自我成长',
    excerpt: '亲密关系不仅提供陪伴和温暖，更是一面映照自我的镜子。学会在关系中觉察和成长，让爱成为最好的老师。',
    content: `<p>最好的亲密关系不仅仅是两个人的相伴，更是两个灵魂的共同进化。当我们以成长的心态对待爱情时，关系中的每一次挑战都变成了自我提升的机会。</p>

<h2>关系是一面镜子</h2>
<p>伴侣常常能照出我们自己看不到的盲点。当你对伴侣的某个行为特别敏感或反应过度时，这往往反映了你自己内在的某个未解决的课题。把关系当作自我觉察的工具。</p>

<h2>触发点是成长的邀请</h2>
<p>关系中那些让你感到愤怒、受伤或害怕的瞬间，恰恰是最有价值的成长契机。与其回避或对抗这些触发点，不如好奇地探索：这些强烈反应背后是什么？</p>

<h2>练习脆弱的力量</h2>
<p>真正的亲密需要勇气——勇于展示自己的不完美，勇于表达真实的需求，勇于在不确定中保持开放。每一次选择脆弱而非防御，都是自我成长的突破。</p>

<h2>在关系中保持自我</h2>
<p>健康的成长不是把自己完全改变成对方想要的样子，而是在关系中更加清晰地认识自己、接纳自己。最好的爱情是两个完整的个体选择在一起，而非两个半个人拼凑成整体。</p>`,
    author: '陈文静',
    authorTitle: '心理咨询师',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20with%20gentle%20smile%2C%20simple%20cream%20background%2C%20warm%20lighting%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20approachable%20look&width=200&height=200&seq=author-cw-06&orientation=squarish',
    date: '2026-07-01',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20person%20standing%20on%20a%20hilltop%20at%20sunrise%2C%20arms%20open%2C%20warm%20golden%20light%2C%20growth%20and%20hope%20symbolism%2C%20inspiring%20atmosphere%2C%20cream%20and%20warm%20amber%20tones%2C%20fine%20art%20photography&width=1200&height=675&seq=article-grow-09&orientation=landscape',
    featured: false,
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((article) => article.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getFeaturedArticles = () => {
  return articles.filter((article) => article.featured);
};

export const getRecentArticles = (count: number = 3) => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};

export const getCategoryNameBySlug = (slug: string) => {
  const cat = categories.find((c: any) => c.slug === slug);
  return cat ? cat.name : '';
};